import disposableDomains from "disposable-email-domains";

// Domains confirmed in our user base that aren't yet in the npm package
const CUSTOM_BLOCKED_DOMAINS = new Set([
  "googxs.com",       // fake Google typosquat
  "nowhere-test.xyz", // test domain, 8 throwaway signups observed
  "gmail.comm",       // typo of gmail.com
  "hjily.yr",         // invalid TLD
  "ruutukf.com",      // random-char throwaway
  "jkotypc.com",      // random-char throwaway
  "fxavaj.com",       // random-char throwaway
  "mkzaso.com",       // random-char throwaway
  "aqqor.com",        // random-char throwaway
  "nespj.com",        // random-char throwaway
  "necub.com",        // random-char throwaway
  "wshu.net",         // random-char throwaway
  "denipl.com",       // random-char throwaway
]);

const disposableSet = new Set([...(disposableDomains as string[]), ...CUSTOM_BLOCKED_DOMAINS]);

// Privacy relay services that are legitimate — real users with privacy concerns
const ALLOWED_RELAY_DOMAINS = new Set([
  "privaterelay.appleid.com", // Apple Hide My Email
  "duck.com",                 // DuckDuckGo Email Protection
  "mozmail.com",              // Firefox Relay
  "simplelogin.io",           // SimpleLogin
  "addy.io",                  // Addy.io
  "anonaddy.com",             // AnonAddy
  "aleeas.com",               // Aleeas
  "relay.firefox.com",        // Firefox Relay (legacy)
]);

export function isDisposableEmail(email: string): boolean {
  const domain = email.split("@")[1]?.toLowerCase();
  if (!domain) return false;
  if (ALLOWED_RELAY_DOMAINS.has(domain)) return false;
  return disposableSet.has(domain);
}
